import { ILongBanner as IContentfulLongBanner } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { IProps as ILongBanner } from 'marketing-site/src/library/components/LongBanner'
import { LongBanner } from 'marketing-site/src/library/components/LongBanner/component'
import { CTA } from 'marketing-site/src/transformers/CTA'
import { transformImage } from '../elements/ContentfulImage'
import React from 'react'
import { getHexColorFromName, Color } from 'marketing-site/src/library/utils'

export const ContentfulLongBanner = (rooflineBanner: IContentfulLongBanner) => (
  <EntryMarker entry={rooflineBanner}>
    {() => <LongBanner {...transformLongBanner(rooflineBanner)} />}
  </EntryMarker>
)

export function transformLongBanner({ fields }: IContentfulLongBanner): ILongBanner {
  return {
    ...fields,
    renderCTA: () => fields.cta && <CTA {...fields.cta} />,
    text: fields.text,
    bgImage: fields.bgImage ? transformImage(fields.bgImage) : undefined,
    bgColor: getHexColorFromName(fields.bgColor) as Color,
  }
}
